import { AVAILABLE_ROUTES } from '@/const/route'
import { createRouter, createWebHistory } from 'vue-router'
import { requiresAuth } from './guards/requiresAuth'
import { requiresRubixClaim } from './guards/requiresRubixClaim'
import { requiresAppAccess } from './guards/requiresAppAccess'
import { requiresRole } from './guards/requiresRole'
import { cleanupQueryParams } from './guards/cleanupQueryParams'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: AVAILABLE_ROUTES,
  strict: true,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

// Register navigation guards in order of execution
// Order matters: auth -> claims -> access -> role -> query cleanup
router.beforeEach(requiresAuth)
router.beforeEach(requiresRubixClaim)
router.beforeEach(requiresAppAccess)
router.beforeEach(requiresRole)
router.beforeEach(cleanupQueryParams)

export default router
